import {Component, Input, OnInit} from '@angular/core'
import {OptionsNgxOwCarouselService} from 'dmmp-services'

@Component({
  selector: 'dmmp-features-carousel',
  templateUrl: './features-carousel.component.html',
})

export class FeaturesCarouselComponent implements OnInit {
  @Input() identifier
  @Input() data
  configBenefits

  constructor(private options: OptionsNgxOwCarouselService) {
  }

  ngOnInit() {
    this.configBenefits = this.data ? this.options.configurationBenefits(this.data) : ''
  }
}

